const ManagerFAQContentKeys = [
    {
        questionKey : 'new_productoverview_manager.FAQ_QUESTION1',
        answerKey: 'new_productoverview_manager.FAQ_QUESTION_1_ANSWER'
    },
    {
        questionKey : 'new_productoverview_manager.FAQ_QUESTION2',
        answerKey: 'new_productoverview_manager.FAQ_QUESTION_2_ANSWER'
    },
    {
        questionKey : 'new_productoverview_manager.FAQ_QUESTION3',
        answerKey: 'new_productoverview_manager.FAQ_QUESTION_3_ANSWER'
    },
    {
        questionKey : 'new_productoverview_manager.FAQ_QUESTION4',
        answerKey: 'new_productoverview_manager.FAQ_QUESTION_4_ANSWER'
    },
    {
        questionKey : 'new_productoverview_manager.FAQ_QUESTION5',
        answerKey: 'new_productoverview_manager.FAQ_QUESTION_5_ANSWER'
    },
    {
        questionKey : 'new_productoverview_manager.FAQ_QUESTION6',
        answerKey: 'new_productoverview_manager.FAQ_QUESTION_6_ANSWER'
    },
    {
        questionKey : 'new_productoverview_manager.FAQ_QUESTION7',
        answerKey: 'new_productoverview_manager.FAQ_QUESTION_7_ANSWER'
    },
    {
        questionKey : 'new_productoverview_manager.FAQ_QUESTION8',
        answerKey: 'new_productoverview_manager.FAQ_QUESTION_8_ANSWER'
    },
]

export default ManagerFAQContentKeys